import { render, staticRenderFns } from "./uploader-img.vue?vue&type=template&id=2eecc548&scoped=true"
import script from "./uploader-img.vue?vue&type=script&lang=js"
export * from "./uploader-img.vue?vue&type=script&lang=js"
import style0 from "./uploader-img.vue?vue&type=style&index=0&id=2eecc548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eecc548",
  null
  
)

export default component.exports